import { any, func } from "prop-types";
import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  submitDrivingOnboarding,
  uploadDocumentation,
} from "../../redux/actions";
import { downloadDrivingForm } from "../../api/profileApi";
import ReadingStatus from "../ReadingListDownload/reading_status";
import { resourcePdfDownload } from "../../containers/ResourceFolders/util";
import * as listStyle from "../ReadingList/styles.module.scss";
import * as style from "./styles.module.scss";
import OnboardingListItem from "../OnboardingListItem/OnboardingListItem";
import DrivingTestListItem from "../DrivingTestListItem/DrivingTestListItem";
import { Button } from "../../common";
import Spinner from "../../common/Spinner";
import Popup from "../../common/Popup/Popup";
import FileDropzone from "../../common/FileDropzone/FileDropzone";
import { useWindowDimensions } from "../../helpers/hooks";
import { isMobile } from "../../helpers";

const DrivingOnboarding = ({
  appData,
  submitDrivingOnboardingFunc,
  submitDocument,
}) => {
  const drivingOnboarding = appData.drivingOnboarding || {};
  const documentationFiles = appData.documentationFiles || [];
  const [invalidDoc, setInvalidDoc] = useState(true);
  const { height } = useWindowDimensions();
  const submitted = drivingOnboarding && drivingOnboarding.submitted === true;
  const [loading, setLoading] = useState(false);
  const [popupOpen, setPopupOpen] = useState("");
  const [drivingDocs, setDrivingDocs] = useState({
    "Driving Licence front": null,
    "Driving Licence back": null,
    "CPC Card front": null,
    "CPC Card back": null,
    "Digi Card": null,
  });

  useEffect(() => setLoading(false), [submitted]);
  const readingListWithStatus = [
    {
      status: drivingOnboarding.skillsAndQualifications
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
      title: "Skills & Qualifications",
      link: "skills-and-qualifications",
    },
    {
      status: drivingOnboarding.licenceDetailsAndDvlaCheck
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
      title: "Licence Details & DVLA Check",
      link: "licence-details-and-dvla-check",
    },
    {
      status: drivingOnboarding.complianceAndDriversDeclaration
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
      title: "Compliance & Drivers Declaration",
      link: "compliance-and-drivers-declaration",
    },
  ];

  const driverAssessments = [
    {
      status:
        appData.nonHGVSubmitted && appData.nonHGVPassed
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Non HGV Driver Assessment",
      link: "non-hgv-assessment",
      formname: "getNonHGVAsssessment",
      filename: "Non_HGV_Assessment",
    },
    {
      status:
        appData.driverAssesmentSubmitted && appData.driverAssessmentPassed
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "HGV Driver Assessment",
      link: "driver-assessment",
      formname: "getDriverAssessment",
      filename: "Driver_Assessment",
    },
  ];

  const canSubmit = readingListWithStatus.every(
    (doc) => doc.status === ReadingStatus.Done
  );

  const handleSubmit = () => {
    setLoading(true);
    submitDrivingOnboardingFunc(appData.drivingOnboarding);
  };

  const handleSubmitDocument = (title) => {
    const typeCodes = new Map([
      ["Driving Licence front", "JPDL"],
      ["Driving Licence back", "JDLB"],
      ["CPC Card front", "JCPC"],
      ["CPC Card back", "JCPB"],
      ["Digi Card", "JDIG"],
    ]);

    const document = {
      displayName: title,
      documentFile: drivingDocs[title],
      fileTypeCode: typeCodes.get(title),
    };

    submitDocument(document);
    setPopupOpen(false);
  };

  const documentsToUpload = [
    {
      status:
        documentationFiles.filter((e) => e.TypeCode === "JPDL").length > 0
          ? 3
          : 1,
      title: "Driving Licence front",
    },
    {
      status:
        documentationFiles.filter((e) => e.TypeCode === "JDLB").length > 0
          ? 3
          : 1,
      title: "Driving Licence back",
    },
    {
      status:
        documentationFiles.filter((e) => e.TypeCode === "JCPC").length > 0
          ? 3
          : 1,
      title: "CPC Card front",
    },
    {
      status:
        documentationFiles.filter((e) => e.TypeCode === "JCPB").length > 0
          ? 3
          : 1,
      title: "CPC Card back",
    },
    {
      status:
        documentationFiles.filter((e) => e.TypeCode === "JDIG").length > 0
          ? 3
          : 1,
      title: "Digi Card",
    },
  ];

  const triggerDownload = () => {
    setLoading(true);
    downloadDrivingForm().then((response) => {
      const link = document.createElement("a");
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });
      link.href = window.URL.createObjectURL(blob);
      link.download = `driving_forms.pdf`;
      link.click();
      setLoading(false);
    });
  };

  const onImageUpload = (key, value) => {
    setDrivingDocs({ ...drivingDocs, [key]: value });
  };

  const calculateDropzoneHeight = () => {
    const paddings = 4 * 16;
    const buttons = 2 * 31;
    const dropzoneHeight = 0.6 * height - buttons - paddings;
    return `${dropzoneHeight}px`;
  };

  const handleUpload = (title) => {
    return (
      <Popup isOpen={true} handleCloseClick={() => setPopupOpen("")} overNav>
        <FileDropzone
          dropFileMsg={`Drop your ${title} image here`}
          fileTypeHint="Choose an image of your document. This should be a JPEG or PNG file."
          acceptedFileTypes=".jpg,.jpeg,.png"
          handleChange={onImageUpload}
          fileStateName={title}
          fileParsedToString={drivingDocs[title]}
          wrongFileTypeHint="Your image needs to be provided as a JPEG or PNG file."
          fileCategory="image"
          isFileValid={invalidDoc}
          handleInvalidType={() => {
            setInvalidDoc(true);
          }}
          height={calculateDropzoneHeight()}
          width="100%"
          imageMaxWidth="100%"
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginRight: "20px",
          }}
        >
          <button
            style={{ maxWidth: "100px", marginRight: "10px" }}
            className="btn btn-primary my-sm-2 ml-sm-2 col-12 col-sm-3 col-lg-2"
            onClick={() => setPopupOpen("")}
          >
            Cancel
          </button>
          <button
            style={{ maxWidth: "100px" }}
            className="btn btn-primary my-sm-2 ml-sm-2 col-12 col-sm-3 col-lg-2"
            onClick={() => handleSubmitDocument(title)}
            disabled={drivingDocs[title] === null}
          >
            Upload
          </button>
        </div>
      </Popup>
    );
  };

  const determineStatus = (status) => {
    if (submitted) {
      return 3;
    }
    if (status === 2) {
      return 4;
    }
    return status;
  };

  return (
    <div className="container text-bluishGray pb-2">
      {popupOpen.length > 0 && handleUpload(popupOpen)}
      <header className="row">
        <div className="col-12">
          <h2 className="section-header pt-2">Driving Onboarding</h2>
          <p className="section-body p-1">
            Please complete all of the below forms. Once you have completed all
            forms, please click on the Submit button to finish your onboarding
            process. Once you have submitted your forms you will be unable to
            edit them. If you have any queries about the forms, please speak to
            your consultant.
          </p>
        </div>
      </header>
      <div className="row">
        <div className="col-lg-6">
          <section className={`section-body pt-1 bg-white`}>
            <h5 className="px-1">Forms to Complete</h5>
            <ul className="list-unstyled">
              {readingListWithStatus.map((elem) => (
                <OnboardingListItem
                  key={elem.title}
                  url={
                    submitted
                      ? ""
                      : `/profile/edit/driving-onboarding/${elem.link}`
                  }
                  title={elem.title}
                  btnText={
                    elem.status === ReadingStatus.Todo
                      ? "Enter Details"
                      : "Edit"
                  }
                  subtitle={elem.description}
                  status={determineStatus(elem.status)}
                />
              ))}
            </ul>

            <div className={style.buttonContainer}>
              {submitted ? (
                <button
                  className={`btn btn-primary ${style.onboarding__btn}`}
                  onClick={() => triggerDownload()}
                  disabled={loading ? "disabled" : ""}
                >
                  Download Completed Forms
                </button>
              ) : (
                <Fragment>
                  <div className={style.submitButtonDesktop}>
                    Please click on the Submit button for your forms to be sent
                    to HRGO.
                  </div>
                  <Button
                    classes={`btn btn-primary ${style.buttonSubmit}`}
                    disabled={canSubmit && !loading ? "" : "disabled"}
                    onClick={() => handleSubmit()}
                  >
                    {loading ? (
                      <Fragment>
                        Submit <Spinner />
                      </Fragment>
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Fragment>
              )}
            </div>
          </section>
        </div>
        <br></br>

        <div className="col-lg-6">
          <section className={`section-body pt-1 bg-white`}>
            <h5 className="px-1">Assessments to Complete</h5>
            <h6 className="px-1">
              (Please only complete the relevant assessment)
            </h6>
            <ul className="list-unstyled">
              {driverAssessments.map((elem) => (
                <DrivingTestListItem
                  key={elem.title}
                  url={`/profile/edit/driving-onboarding/${elem.link}`}
                  title={elem.title}
                  btnText={
                    elem.status === ReadingStatus.Todo ? "Complete" : "Download"
                  }
                  subtitle={elem.description}
                  status={elem.status}
                  downloadPDFFile={async () =>
                    resourcePdfDownload(elem.formname, elem.filename)
                  }
                />
              ))}
            </ul>
          </section>
          {isMobile ? (
            <section className={`section-body pt-1 bg-white`}>
              <h5 className="px-1">Documents to Upload</h5>
              <div
                className={`${style.onboarding__wrapper} flex-column flex-sm-row`}
              >
                <Link
                  to={"/profile/edit/driving-onboarding/upload"}
                  style={{ minWidth: "106px" }}
                  className={`btn btn-primary ml-sm-1 mt-hf mt-sm-0 ${style.onboarding__btn}`}
                >
                  Upload
                </Link>
              </div>
              {documentsToUpload.map((elem) => (
                <OnboardingListItem
                  key={elem.title}
                  title={elem.title}
                  status={elem.status}
                />
              ))}
            </section>
          ) : (
            <section className={`section-body pt-1 bg-white`}>
              <h5 className="px-1">Documents to Upload</h5>
              {documentsToUpload.map((element, i) => (
                <OnboardingListItem
                  title={element.title}
                  status={element.status}
                  key={i}
                  upload={true}
                  handleClick={() => setPopupOpen(element.title)}
                  btnText="Upload"
                />
              ))}
            </section>
          )}
        </div>
      </div>
      <div className="w-100 d-flex justify-content-end mt-2">
        <Link to="/profile" className="btn btn-primary px-3">
          Back to My Account
        </Link>
      </div>
    </div>
  );
};
DrivingOnboarding.propTypes = {
  appData: any,
  submitDrivingOnboardingFunc: func.isRequired,
  submitDocument: func,
};
const mapDispatchToProps = {
  submitDrivingOnboardingFunc: submitDrivingOnboarding,
  submitDocument: uploadDocumentation,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(DrivingOnboarding);
